import { render } from "./CollectionDetailedSearchImperialDiet.vue?vue&type=template&id=4a77442e&scoped=true&ts=true"
import script from "./CollectionDetailedSearchImperialDiet.vue?vue&type=script&lang=ts"
export * from "./CollectionDetailedSearchImperialDiet.vue?vue&type=script&lang=ts"

import "./CollectionDetailedSearchImperialDiet.vue?vue&type=style&index=0&id=4a77442e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src186255619/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a77442e"]])

export default __exports__